import { useEffect, FC } from "react";
import { useLocation } from "react-router-dom";
import { recordPageView, logUserAction } from "./utils/rum";

const ScrollToTop: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (pathname) {
      recordPageView(pathname);
      logUserAction(`Navigate: ${pathname}`, { path: pathname });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;